import { useIntl } from 'react-intl';
import { ApiFilterOperation, FieldFilter } from '@eas/common-web';

export const useFilterFields = () => {
  const intl = useIntl();
  return [
    {
      label: intl.formatMessage({
        id: 'ZSD__USER__ABSENCE__TABLE__COLUMN__NAME',
        defaultMessage: 'Názov',
      }),
      datakey: 'absenceType.name',
      filterkey: 'absenceType.name',
      defaultOperation: ApiFilterOperation.CONTAINS,
      FilterComponent: FieldFilter.FilterTextCell,
    },
    {
      label: intl.formatMessage({
        id: 'ZSD__USER__ABSENCE__TABLE__COLUMN__VALID_FROM',
        defaultMessage: 'Platná od',
      }),
      datakey: 'fromDate',
      filterkey: 'fromDate',
      defaultOperation: ApiFilterOperation.LTE,
      FilterComponent: FieldFilter.FilterDateCell,
    },
    {
      label: intl.formatMessage({
        id: 'ZSD__USER__ABSENCENT__TABLE__COLUMN__VALID_TO',
        defaultMessage: 'Platná do',
      }),
      datakey: 'toDate',
      filterkey: 'toDate',
      defaultOperation: ApiFilterOperation.GTE,
      FilterComponent: FieldFilter.FilterDateCell,
    },
    {
      label: intl.formatMessage({
        id: 'ZSD__USER__ABSENCE__TABLE__COLUMN__ALLOWED',
        defaultMessage: 'Schválená',
      }),
      datakey: 'allowed',
      filterkey: 'allowed',
      defaultOperation: ApiFilterOperation.EQ,
      FilterComponent: FieldFilter.FilterBooleanCell,
    },
  ];
};
